module.exports = __webpack_public_path__ + "img/attention.b1eca999.svg";